import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';

export const useViewTransition =
  typeof document !== 'undefined' && 'startViewTransition' in document
    ? <T>(newValue: T) => {
        const [value, setValue] = useState(newValue);

        useEffect(() => {
          if (value !== newValue)
            document.startViewTransition(() => {
              flushSync(() => {
                setValue(newValue);
              });
            });
        }, [newValue]);

        return value;
      }
    : <T>(value: T) => value;
